import * as Sentry from "@sentry/react"
import * as SentryBrowser from "@sentry/browser"
import React from "react"
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router"
import { settings } from "./settings"

// TODO: Replace with your actual DSNs for development and staging
const dsn = "https://e267da2f108a34ab6719cb3d1a634b78@o4506343914078208.ingest.sentry.io/4506343970308096"

const sentryOptions = {
  dsn: dsn,
  environment: settings.SENTRY_ENV,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes
    }),
    Sentry.captureConsoleIntegration({
      levels: ["error"]
    })
  ],
  tracesSampleRate: 0.0, // Default to production
  replaysSessionSampleRate: 0.0, // Default to production
  replaysOnErrorSampleRate: 0.0 // Default to production
}

switch (settings.SENTRY_ENV) {
  case "development":
    break
  case "staging":
    break
  case "production":
    // DSN and rates are already set to production defaults
    break
  default:
    // Optionally handle other environments or fall back to production
    console.warn(`Sentry: Unknown environment '${settings.SENTRY_ENV}', falling back to production DSN.`)
    // No DSN change, use production DSN if not explicitly matched
    // Sample rates will use the defaults specified above (production rates)
    break
}

Sentry.init(sentryOptions)

SentryBrowser.init({
  dsn: dsn,
  environment: settings.SENTRY_ENV
  // integrations: [
  //   SentryBrowser.captureConsoleIntegration({
  //     levels: ["error"]
  //   })
  // ]
})
